



 <main *ngIf="sharedService.selectedDevice" fxLayout="column" fxLayoutAlign="flex-start center">
   <section id="main-section">



     <div>
       <button class="card-button" mat-flat-button color="accent" (click)="applyToAllDeviceFromGroup()" disabled>{{'applyToAll' | translation}}</button>
     </div>


     <p class="main-title">{{'kioskModuleTitle' | translation}}</p>
     <p class="main-subtitle">{{'kioskModuleDescription' | translation}}</p>
     <button [disabled]="isSoloKiosk" type="button" mat-flat-button color="primary" color="accent" (click)="addUrl()">
       <mat-icon>add</mat-icon> {{'addWebPage' | translation}}
     </button>
     
     <p class="sub-message" *ngIf="isSoloKiosk">{{ 'multiKioskAvailable' | translation }}</p>

     <div class="card" fxLayout="row" fxLayoutAlign="flex-start flex-start">
       <section class="card-section" fxLayout="column" fxLayoutAlign="flex-start flex-start">
         <div>
           <p> {{'lockDomaine' | translation}} </p>
           <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="configForm.urlLock" (ngModelChange)="setValue()">
           </mat-slide-toggle>
         </div>
         <div>
           <p> {{'deleteCookies' | translation}} </p>
           <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="configForm.cookiesSuppression" (ngModelChange)="setValue()">
           </mat-slide-toggle>
         </div>
       </section>
     </div>


     <div class="card" fxLayout="row" fxLayoutAlign="flex-start flex-start">

       <section class="card-section" fxLayout="column" fxLayoutAlign="flex-start flex-start" *ngFor="let item of configForm.urlConfig; let i = index">
         <div id="url-element" fxLayout="row">
           <div id="webpage-datas-wrapper" fxLayout="row" fxLayout="flex-start center">

             <img *ngIf="item.thumbnailUrl" class="thumbnail" [src]="item.thumbnailUrl" />
             <img *ngIf="!item.thumbnailUrl" class="thumbnail" src="assets/img/web-placeholder.jpg" />

             <div fxLayout="column" class="wrapper">
               <p *ngIf="!item.name" class="card-title">{{'missingLabel' | translation}}</p>
               <p *ngIf="item.name" class="card-title">{{item.name}}</p>
               <p *ngIf="!item.url" class="card-subtitle">{{'missingURL' | translation}}</p>
               <p *ngIf="item.url" class="card-subtitle limit-text">{{item.url}}</p>
             </div>
           </div>

           <div>
             <button class="card-button" mat-raised-button color="accent" [disabled]="disableModification" (click)="showModal(item, i)"><mat-icon>settings</mat-icon></button>
             <button class="card-button" mat-raised-button color="warn" [disabled]="disableModification" (click)="removeUrl(item)"><mat-icon>delete</mat-icon></button>
           </div>


         </div>

         <div class="divider"> </div>

       </section>





     </div>

   </section>

</main>





<!--
<main fxLayout='column' fxLayoutAlign="space-between center">

    <form #form="ngForm" (ngSubmit)="submit(form.value)" fxLayout='column' fxLayoutAlign="center center">

        <input class="inputSubmit" color="accent" type='submit' value='Sauvegarder' />

        <div id="matCardWrapper" ngModelGroup="urls">
            <mat-card *ngFor="let item of configForm.urlConfig; let i = index" [ngModelGroup]="i">

                <mat-card-header>

                    <mat-card-title>{{ i + 1 }}</mat-card-title>

                </mat-card-header>

                <mat-card-content>

                    <mat-form-field id="kioskLabel">
                        <input matInput placeholder="Label" name="name" [(ngModel)]="item.name">
                    </mat-form-field>

                    <mat-form-field id="kioskURL">
                        <input matInput placeholder="URL de la page" name="url" [(ngModel)]="item.url">
                    </mat-form-field>

                </mat-card-content>

                <mat-card-actions>

                    <div class="uploadLabelThumbnail" fxLayout="column" fxLayoutAlign="center center">
                        <label>Vignette du bouton</label>
                        <img class="thumbnail" [src]="item.thumbnailUrl" />
                        <input type="file" (change)="addToFilesList($event, 'kiosk/webshot', item)" />

                    </div>
                    <button mat-mini-fab color="warn" (click)="removeUrl(item)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </mat-card-actions>

            </mat-card>
        </div>
        <button type="button" mat-fab color="accent" (click)="addUrl()">
            <mat-icon>add</mat-icon>
        </button>

    </form>

</main> -->





